/* ------------------------------------------------------------------
   Lupo Bianco - Men's Dress Shoes landing page.
   Adds a "Bestseller" label to the product cards listed below.

   This is deliberately theme-scoped: the labels live in this theme
   only, so nothing changes on the live store until this theme is
   published. To change which shoes carry the label, edit BESTSELLERS
   (product handles, exactly as they appear in the product URL).

   Loaded only by templates/collection.shoes.json via a custom-liquid
   section. Safe to delete with that section.
   ------------------------------------------------------------------ */
(function () {
  var BESTSELLERS = [
    'lupo-bianco-milano-leather-penny-loafers',
    'lupo-bianco-firenze-oxford-brogues',
    'lupo-bianco-roma-wholecut-oxford',
    'lupo-bianco-torino-suede-penny-loafers',
    'lupo-bianco-firenze-leather-loafers'
  ];
  var LABEL_TEXT = 'Bestseller';

  function handleFor(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Only the collection grid, never the cart drawer / quick-buy popovers,
  // which render the same product-item markup at thumbnail size.
  var EXCLUDE = '#shopify-section-mini-cart, .mini-cart, .drawer, .popover, .cart-drawer';

  function decorate() {
    var scope = document.querySelector('[id$="__main"]') || document;
    var cards = scope.querySelectorAll('product-item, .product-item');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-lb-bestseller')) return;
      card.setAttribute('data-lb-bestseller', '');

      if (card.closest(EXCLUDE)) return;

      var handle = handleFor(card);
      if (!handle || BESTSELLERS.indexOf(handle) === -1) return;

      var wrapper = card.querySelector('.product-item__image-wrapper');
      if (!wrapper) return;

      var list = wrapper.querySelector('.product-item__label-list');
      if (!list) {
        list = document.createElement('div');
        list.className = 'product-item__label-list label-list';
        wrapper.insertBefore(list, wrapper.firstChild);
      }
      if (list.querySelector('.lb-label--bestseller')) return;

      var label = document.createElement('span');
      label.className = 'label lb-label--bestseller';
      label.textContent = LABEL_TEXT;
      list.insertBefore(label, list.firstChild);
    });
  }

  function init() {
    decorate();
    // The collection grid is re-rendered on filter / sort / pagination,
    // so watch for replaced cards and re-label them.
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        decorate();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
